// src/services/employeeRoleApi.js
// Servicio para roles de empleado (employeeRole.php) - combos

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista roles de empleado (ADMINISTRADOR, ASESOR_VENTA, GERENTE_VENTA, GROOMER)
 * GET employeeRole.php
 */
export const getEmployeeRoles = async () => {
  try {
    const response = await dotoniwoofApi.get('/employeeRole.php');
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al listar roles de empleado:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
